export const getAppVersion = (): string => VITE_APP_VERSION || '0.0.0';
